import { Injectable } from '@angular/core';
import { eErrorMode } from '../models/error';

@Injectable({
  providedIn: 'root'
})

export class ErrorService {

  errorMode: eErrorMode = eErrorMode.NONE;
  queovalError: string = '';
  genericError: any = null;
  genericBody: any = null;
  requestUrl: string = '';

  constructor() { }

  getErrorMode(): eErrorMode {
    return this.errorMode;
  }

  setQueovalError(message: string, requestUrl: string, body: any): void {
    this.errorMode = eErrorMode.QUEOVAL;
    this.queovalError = message;
    this.genericBody = body;
    this.requestUrl = requestUrl;
  }
  setGenericError(message: any, requestUrl: string, body: any): void {
    this.errorMode = eErrorMode.GENERIC;
    this.genericError = message;
    this.genericBody = body;
    this.requestUrl = requestUrl;
  }

  getQueovalError(): string {
    return this.queovalError;
  }
  getGenericError(): any {
    return this.genericError;
  }
  getGenericBody(): any {
    return this.genericBody;
  }

  getRequestUrl(): any {
    return this.requestUrl;
  }
}
